<template>
  <video
    class="base-video"
    :muted="muted || mutedState"
    :autoplay="autoplay"
    :loop="loop"
    playsinline
  />
</template>

<script>
import fetchMedia from '@/utils/fetchMedia'
import { mapGetters } from 'vuex'
export default {
  props: {
    url: {
      type: String,
      required: true
    },
    muted: {
      type: Boolean,
      default: false
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    loop: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loaded: new Promise(async resolve => {
        this.$el.src = await fetchMedia(this.url)
        this.$el.oncanplaythrough = () => {
          this.$emit('loaded')
          this.addOnEndedEventListener()
          resolve()
        }
        this.$el.pause()
        this.$el.load()
      })
    }
  },
  computed: mapGetters('ui', {
    mutedState: 'muted'
  }),
  methods: {
    play () {
      this.$el.play()
    },
    addOnEndedEventListener () {
      this.$el.onended = () => this.$emit('ended')
    }
  }
}
</script>

<style lang="scss" scoped>
.base-video {
  object-fit: cover;
  @media #{$media-3} {
    object-fit: fill;
  }
}
</style>
